import { FormattedMessage } from "react-intl";
import Col from "reactstrap/lib/Col";
import Row from "reactstrap/lib/Row";
import { formatDate } from "../../Utilities/dateUtils";
import {
  AnalysisTabs,
  Finding,
  StatCard,
  findingsForTab,
  formatNumber,
} from "./DailyAnalysisParts";

// Tickets with no automatic link to a client error sort first - they are the most
// valuable outcome and the easiest to bury. No label is shown: the link is only tried
// against client errors, never against log or IIS findings, so "unexplained" would claim
// more than was actually checked. The reader judges for themselves.
function DailyAnalysisSupport({ data }) {
  const support = data.support || {};
  const tickets = findingsForTab(data, AnalysisTabs.SUPPORT);
  const sorted = [...tickets].sort(
    (a, b) => (b.unexplained ? 1 : 0) - (a.unexplained ? 1 : 0),
  );
  const byCategory = support.byCategory || {};

  return (
    <div>
      <Row className="da-equal">
        <Col md sm="6">
          <StatCard
            labelId="DailyAnalysisTickets"
            value={formatNumber(tickets.length)}
            note={
              typeof support.received === "number" ? (
                <FormattedMessage
                  id="DailyAnalysisTicketsBreakdown"
                  values={{
                    received: support.received,
                    internal: support.internal || 0,
                  }}
                />
              ) : (
                ""
              )
            }
          />
        </Col>
        <Col md sm="6">
          <StatCard
            labelId="DailyAnalysisBugReports"
            value={formatNumber(byCategory.BugReport)}
          />
        </Col>
        <Col md sm="6">
          <StatCard
            labelId="DailyAnalysisExplainedByLogs"
            value={formatNumber(support.explainedByLogs)}
            note={
              <FormattedMessage
                id="DailyAnalysisOfBugReports"
                values={{ count: byCategory.BugReport || 0 }}
              />
            }
            tone={
              byCategory.BugReport > 0 && support.explainedByLogs === 0
                ? "crit"
                : null
            }
          />
        </Col>
        <Col md sm="6">
          <StatCard
            labelId="DailyAnalysisQuestions"
            value={formatNumber(
              (byCategory.Support || 0) + (byCategory.Feedback || 0),
            )}
          />
        </Col>
        <Col md sm="6">
          <StatCard
            labelId="DailyAnalysisAplTickets"
            value={formatNumber(byCategory.Apl)}
          />
        </Col>
      </Row>

      <h6 className="da-section-title">
        <FormattedMessage id="DailyAnalysisTickets" />
      </h6>

      {sorted.length === 0 ? (
        <p className="da-empty">
          <FormattedMessage id="DailyAnalysisNoTickets" />
        </p>
      ) : (
        <div className="d-flex flex-column gap-2">
          {sorted.map((ticket) => (
            <Finding key={ticket.key} finding={ticket}>
              <blockquote className="da-quote">
                {ticket.body}
                <footer>
                  {ticket.schools && ticket.schools.length > 0
                    ? ticket.schools.join(", ")
                    : ""}
                  {ticket.timestamp
                    ? ` · ${formatDate(ticket.timestamp, "d MMM HH:mm")}`
                    : ""}
                  {ticket.appVersion ? ` · ${ticket.appVersion}` : ""}
                </footer>
              </blockquote>
            </Finding>
          ))}
        </div>
      )}
    </div>
  );
}

export default DailyAnalysisSupport;
